// extracted by css-extract-rspack-plugin
export default {"root":"DzPPw","input":"V0FLb","label":"ZRwJA","description":"mI9tN","icon":"rxMjC","inner":"TEuML","body":"fokzT"};